// Currency constants shared across the site. Actual prices/discounts are no
// longer hardcoded here — see hooks/usePricing.js, which fetches them from
// GET /api/geo/pricing (backend/config/founderOffer.js is the real single
// source of truth, also used by the actual Stripe charge). This file used to
// also export a static PRICES table and a LAUNCH_END constant that named the
// wrong date entirely (2026-11-11 instead of the real 2026-08-31) — fixed
// 2026-08-26 by removing the duplicate source rather than correcting the date
// again, since a second hardcoded copy is exactly how it drifted the first time.
export const CURRENCIES = ['EUR', 'USD', 'GBP'];
export const CURRENCY_SYMBOLS = { EUR: '€', USD: '$', GBP: '£' };
export const FALLBACK_CURRENCY = 'USD';
